import { message } from "antd";
import { deleteDoc, doc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase/config";

//Handles delete function of the material Tag
export const handleDeleteTag = async (index, widths, value) => {
   let allWidths = widths;
   allWidths.splice(index, 1);
   try {
      const ref = doc(db, "materials", value.id);
      await updateDoc(ref, {
         widths: allWidths,
      }).then(() => {
         message.success(`Updated widths for ${value.material}`);
      });
   } catch (err) {
      message.error(err.message);
   }
};

//handles the stock change
export const handleStockChange = async (value) => {
   let updatedStock = !value.stock;
   try {
      const ref = doc(db, "materials", value.id);
      await updateDoc(ref, {
         stock: updatedStock,
      }).then(() => {
         message.success(`Updated stock!`);
      });
   } catch (err) {
      message.error(err.message);
   }
};

//Delete material
export const deleteMaterial = async (e, docid) => {
   e.preventDefault();
   const ref = doc(db, "materials", docid);
   try {
      await deleteDoc(ref).then(() => {
         message.success("Deleted!");
      });
   } catch (err) {
      message.success(err.message);
   }
};
